import React, { useState } from 'react';
import { useFormikContext } from 'formik';

import OrganizersHostModal from './settings/OrganizersHostModal';
import { useGetMe } from 'legacy/user/hooks';
import OrganizersBadges from 'legacy/common/components/wysiwyg-form/OrganizersBadges';

const Organizers = () => {
  const user = useGetMe();
  const [isOrganizersModalOpen, setIsOrganizersModalOpen] = useState(false);
  const {
    values: {
      groups = [],
      cohosts = [],
      scanners = [],
      operators = [],
      photographers = []
    }
  } = useFormikContext<{
    groups: [];
    cohosts: [];
    scanners: [];
    operators: [];
    photographers: [];
  }>();

  const toggleOrganizersModal = () => {
    setIsOrganizersModalOpen((prevState) => !prevState);
  };

  return (
    <>
      <OrganizersBadges
        onClick={toggleOrganizersModal}
        isEditable
        data={{
          groups,
          cohosts,
          scanners,
          operators,
          photographers,
          host: user
        }}
      />
      <OrganizersHostModal
        isOpen={isOrganizersModalOpen}
        onClose={toggleOrganizersModal}
      />
    </>
  );
};

export default Organizers;
